import axios from "axios";
import toast from 'react-hot-toast';
import { KTSVG } from '../../../_metronic/helpers';
import { downloadFile, extractFilename, getErrorMessage } from '../helpers';
import { flushSync } from "react-dom";
import { useState } from "react";

const API_URL = process.env.REACT_APP_API_URL;

type Props = {
  endpoint: string
  title?: string
  data?: any
}

export const ReportDownloadButton = ({ title = "Export", endpoint, data} : Props) => {

  const [isDownloading, setIsDownloading] = useState(false);

  const processDownload = async () => {
    flushSync(() => {
      setIsDownloading(true);
    });

    try {
      await toast.promise(
        async () => {
          const res = await axios.post(
            `${API_URL}/${endpoint}`,
            data ?? {}, // Fallback to empty object if data is undefined
            {
              responseType: 'blob',
            }
          );
          downloadFile(res.data, extractFilename(res));
        },
        {
          loading: 'Processing',
          success: 'File downloaded.',
          error: (err) => `Download Unsuccessful : ${getErrorMessage(err)}`
        }
      );
    } catch (error) {
      // Gracefully catch unhandled rejections to prevent unhandled promise logs
      console.error('Download failed:', error);    
    } finally {
      setIsDownloading(true);
    };  
  }

  return (
  <div className='d-flex justify-content-end'>
    <div className="rounded border border-solid">
      <div className="d-flex flex-row">
        <div className="fv-row">
          <button
            type='button'
            className='ms-2 btn btn-sm btn-light-primary'
            onClick={processDownload}
            title={title}
            disabled={!endpoint || isDownloading }
          >
            <KTSVG path='/media/icons/duotune/arrows/arr091.svg' className='svg-icon-2'  />
            {title}
          </button>
        </div>
      </div>
    </div>
  </div>
)
}
